// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC3yMipnqVS6fTtLfPDbO3dMZDhYyiTHQc",
  authDomain: "avoid-poop-bc669.firebaseapp.com",
  projectId: "avoid-poop-bc669",
  storageBucket: "avoid-poop-bc669.appspot.com",
  messagingSenderId: "811410059748",
  appId: "1:811410059748:web:1c699a201d1efd27b297f1",
  measurementId: "G-TY28S5K1ZR",
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
const fireStore = getFirestore(firebase);
const fireAuth = getAuth(firebase);

export { fireStore, fireAuth };

// const analytics = getAnalytics(app);
